import React from 'react';
import * as Styled from './styles';

const HeaderSkeleton: React.FC = () => (
  <Styled.Card>
    <Styled.TopRow>
      <Styled.Info>
        <Styled.MainTitle />
        <Styled.SubTitle />
        <Styled.AddressLine width='70%' />
      </Styled.Info>
      <Styled.ButtonPlaceholder />
    </Styled.TopRow>
  </Styled.Card>
);

export default HeaderSkeleton;
